import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IPlaybookListFacadeService } from "../../legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-list.facade.service";

import * as EditTemplateActions from './edit-template-store.action';
import * as EditTemplateSelectors from './edit-template-store.selector';
import { IPlaybooksItemDTO } from "../../legal-hub/dto/playbooks-listening.dto";
import { IGuideLineListFilter } from "../../legal-hub/playbooks/playbook-list/playbook-list.component";
import { FieldSettings } from "../../events/editor-emitter.dto";
import { EditorEmitterService } from "../../events/editor-emitter.service";
import { IPlaybookGuidelineRunItem } from "../../legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-guideline-run-tile.component";
import { PopoverSettingMenu } from "../edit-template.dto";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'any'
})
export class EditTemplatePlaybookListFacadeService implements IPlaybookListFacadeService {
  legalHubFilters$ = this._store.select(EditTemplateSelectors.selectLegalHubFilters);
  legalHubSelectedPlaybook$ = this._store.select(EditTemplateSelectors.selectedLegalHubPlaybook);
  rightBarHigherZindex$ = this._store.select(EditTemplateSelectors.rightBarHigherZindex);

  constructor(private _store:Store, private editorEmitterService: EditorEmitterService) { }

  setLegalHubFilters(filters: IGuideLineListFilter){
      this._store.dispatch(EditTemplateActions.setLegalHubFilters({ filters }));
  }

  setLegalHubPlaybook(playbook: IPlaybooksItemDTO){
      this._store.dispatch(EditTemplateActions.selectLegalHubPlaybook({ playbook }));
  }

  setRightBarHigherZindex(higher: boolean):void{
      this._store.dispatch(EditTemplateActions.rightBarHigherZindex({ higher }));
  }

  openLegalHubSidebar(guideLine:IPlaybookGuidelineRunItem): void {
      this.editorEmitterService.triggerOpenMenuAction({rightMenuType:PopoverSettingMenu.legalHubSettings, fieldSettings:{
              ...guideLine?.details as unknown as FieldSettings
          }});
      this.setRightBarHigherZindex(true);
  }
}